<!-- One number that matters, with what it means. Factory-owned. Styles in kit.css.

     Put tiles in `<div class="kit-stats">`. Only for values the app actually
     holds — a tile showing a made-up metric is decoration pretending to be
     data. -->
<template>
  <div class="kit-stat">
    <p class="kit-stat__label">{{ label }}</p>
    <p class="kit-stat__value">{{ value }}</p>
    <p v-if="hint" class="kit-stat__hint">{{ hint }}</p>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], required: true },
  hint: { type: String, default: '' },
});
</script>
